import React, { useState } from "react";
import ReactDOM from "react-dom";
import { showMessage } from "../../Functionalities/Functions";
import { savePayout } from "./Logic";

export const todayInIndia = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date());

const initialValues = (payout) => ({
  branch: payout?.branch ? String(payout.branch) : "",
  amount: payout?.amount ?? "",
  transaction_type: payout?.transaction_type ?? "",
  transaction_mode: payout?.transaction_mode ?? "",
  transaction_id: payout?.transaction_id ?? "",
  paid_on: payout?.paid_on ?? todayInIndia(),
  notes: payout?.notes ?? "",
});

const Field = ({ label, required, children }) => (
  <div className="form-group">
    <label className="text-black font-w500">
      {label}
      {required && <span className="text-danger"> *</span>}
    </label>
    {children}
  </div>
);

export default function PayoutFormModal({ payout, branches, options, onClose, onSaved }) {
  const [values, setValues] = useState(() => initialValues(payout));
  const [saving, setSaving] = useState(false);
  const isEdit = Boolean(payout?.id);

  const change = (name) => (event) => setValues((prev) => ({ ...prev, [name]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    if (!values.branch || !values.amount || !values.transaction_type) {
      showMessage("Restaurant, amount and transaction type are required", "danger", "Missing details", "top", "top-right");
      return;
    }
    setSaving(true);
    const body = await savePayout(payout?.id, values);
    setSaving(false);
    if (body && body.Status === true) {
      showMessage(body.Message, "success", "Saved", "top", "top-right");
      onSaved();
      return;
    }
    showMessage((body && body.Error) || "Could not save the payout", "danger", "Error!", "top", "top-right");
  };

  return ReactDOM.createPortal(
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
        onMouseDown={(event) => event.target === event.currentTarget && !saving && onClose()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isEdit ? "Edit payout" : "Record a payout"}</h5>
              <button type="button" className="close" onClick={onClose} aria-label="Close" disabled={saving}>
                <span>×</span>
              </button>
            </div>
            <form onSubmit={submit}>
              <div className="modal-body">
                <Field label="Restaurant" required>
                  <select className="form-control" value={values.branch} onChange={change("branch")}>
                    <option value="">Choose a restaurant</option>
                    {branches.map((branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ))}
                  </select>
                </Field>
                <div className="row">
                  <div className="col-sm-6">
                    <Field label="Amount (₹)" required>
                      <input
                        className="form-control"
                        type="number"
                        min="0.01"
                        step="0.01"
                        inputMode="decimal"
                        value={values.amount}
                        onChange={change("amount")}
                        placeholder="1500"
                      />
                    </Field>
                  </div>
                  <div className="col-sm-6">
                    <Field label="Transaction type" required>
                      <select className="form-control" value={values.transaction_type} onChange={change("transaction_type")}>
                        <option value="">Choose a type</option>
                        {options.transaction_types.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </Field>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field label="Transaction mode">
                      <select className="form-control" value={values.transaction_mode} onChange={change("transaction_mode")}>
                        <option value="">Not given</option>
                        {options.transaction_modes.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </Field>
                  </div>
                  <div className="col-sm-6">
                    <Field label="Paid on">
                      <input
                        className="form-control"
                        type="date"
                        max={todayInIndia()}
                        value={values.paid_on}
                        onChange={change("paid_on")}
                      />
                    </Field>
                  </div>
                </div>
                <Field label="Transaction ID / reference">
                  <input
                    className="form-control"
                    maxLength={100}
                    value={values.transaction_id}
                    onChange={change("transaction_id")}
                    placeholder="UTR, cheque number…"
                  />
                </Field>
                <Field label="Notes">
                  <textarea
                    className="form-control"
                    rows={3}
                    maxLength={1000}
                    value={values.notes}
                    onChange={change("notes")}
                  />
                </Field>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={onClose} disabled={saving}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? "Saving…" : isEdit ? "Save changes" : "Record payout"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>,
    document.body,
  );
}
